import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { tap } from 'rxjs/operators';

import { LendingType } from '@shared/models/lending-type';
import { LenderHubService } from '@shared/services';
import { LenderHubDataService } from '@shared/services/lenderhub-data.service';
import { LendingTypeService } from '@shared/services/lending-type.service';

export const lendingTypeResolver: ResolveFn<LendingType[]> =
  (route: ActivatedRouteSnapshot) => {
    const lendingTypeService = inject(LendingTypeService);
    const lenderHubDataService = inject(LenderHubDataService);
    const lenderHubService = inject(LenderHubService);

    let url = 'lendingtypes';
    const lenderNameId = lenderHubService.lenderName?.lenderNameId;
    if (typeof lenderNameId === 'number') {
      url += `?lenderNameId=${lenderNameId}`;
    }

    return lenderHubDataService.get<LendingType[]>(url).pipe(
      tap((types: LendingType[]) => {
        lendingTypeService.lendingTypes = types.filter(t => !t.archived);
        lendingTypeService.lendingType = types.find(x => x.id === +route.params.lendingTypeId);
      }),
    );
  };
